import { useTranslation } from "react-i18next";
import { CheckCircle2, Circle } from "lucide-react";

import { PASSWORD_RULES, validatePassword } from "../../application/passwordRules";

/** Live checklist of the password rules, ticking each one as it is met. */
export default function PasswordRequirements({ password }: { password: string }) {
  const { t } = useTranslation();
  const validation = validatePassword(password);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-4 p-4 rounded-2xl bg-gray-50 dark:bg-white/[0.02] border border-gray-100 dark:border-white/[0.05]">
      {PASSWORD_RULES.map((rule) => (
        <div key={rule} className="flex items-center gap-2">
          {validation[rule] ? (
            <CheckCircle2 className="w-4 h-4 text-brand-500" />
          ) : (
            <Circle className="w-4 h-4 text-gray-300 dark:text-gray-700" />
          )}
          <span className={`text-xs ${validation[rule] ? "text-content-primary font-medium" : "text-gray-500"}`}>
            {t(`auth.passwordReq.${rule}`)}
          </span>
        </div>
      ))}
    </div>
  );
}
